import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/inventory/')({
  loader: () => {
    throw redirect({
      from: Route.fullPath,
      to: '/inventory/outlet',
    })
  },
})
